import React, { useEffect, useState } from "react";
import { WorkingStatus } from "../../redux/api-model/employees/workContract";
import { TimetrackingRequestDto } from "../../redux/api-model/employees/workSchedule";
import {
  millisecondsToHours,
  getMinutes,
  millisecondsToMinutes,
} from "date-fns/fp";
import {
  addLeadingZero,
  getLastInterval,
  getTotalDuration,
} from "../../utils/duration";
import { useTheme } from "styled-components";

interface WatchProps {
  working?: WorkingStatus;
  workingTimetrackingRequest?: TimetrackingRequestDto;
}

const Watch: React.FC<WatchProps> = ({
  working,
  workingTimetrackingRequest,
}) => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const theme = useTheme();

  if (
    timezone !== "Europe/Berlin" ||
    working === WorkingStatus.NOT_WORKING ||
    !workingTimetrackingRequest ||
    !workingTimetrackingRequest.startTime
  ) {
    return null;
  }

  const [currentTime, setCurrentTime] = useState<Date>(new Date());

  useEffect(() => {
    const intervalId = setInterval(() => setCurrentTime(new Date()), 1000);

    return () => clearInterval(intervalId);
  }, []);

  let totalDurationInMilliseconds = getTotalDuration(
    currentTime,
    working,
    workingTimetrackingRequest
  );

  if (totalDurationInMilliseconds < 0) {
    totalDurationInMilliseconds = 0;
  }

  let lastIntervalInMilliseconds = getLastInterval(
    currentTime,
    working,
    workingTimetrackingRequest
  );

  if (lastIntervalInMilliseconds < 0) {
    lastIntervalInMilliseconds = 0;
  }

  const workingTime = `${addLeadingZero(
    millisecondsToHours(totalDurationInMilliseconds)
  )}:${addLeadingZero(getMinutes(totalDurationInMilliseconds))}`;

  const timeOnBrake = `${addLeadingZero(
    millisecondsToHours(lastIntervalInMilliseconds)
  )}:${addLeadingZero(getMinutes(lastIntervalInMilliseconds))}`;

  let cssColor: string;
  switch (true) {
    case working === WorkingStatus.ON_BREAK:
      cssColor = theme.colors.primary1;
      break;
    case millisecondsToMinutes(totalDurationInMilliseconds) > 600:
      cssColor = theme.colors.accent1;
      break;
    case millisecondsToMinutes(totalDurationInMilliseconds) > 480:
      cssColor = theme.colors.accent3;
      break;
    case millisecondsToMinutes(lastIntervalInMilliseconds) > 240:
      cssColor = theme.colors.accent6;
      break;
    default:
      cssColor = theme.colors.accent7;
  }

  return (
    <span style={{ color: cssColor }}>
      {working === WorkingStatus.WORKING ? workingTime : timeOnBrake}
    </span>
  );
};

export default Watch;
